module.exports = __webpack_public_path__ + "static/media/tick01.897b2114.png";